import { FC, Fragment, memo } from 'react'
import classNames from 'classnames'
import { Listing } from 'graphql/types'
import { PAGE_SIZE } from 'lib/search'
import { getEmCasaSessionListings } from 'lib/listing'
import ListingCard from 'components/ListingCard'
import SearchListingCard from './SearchListingCard'
import RecommendationsBanner from './RecommendationsBanner'
import styles from './SearchGridList.module.scss'

export type TProps = {
  loading?: boolean
  listings?: Array<Listing>
  showRecommendationsBanner?: boolean
  recommendationsLength?: number
}

const SearchGridListSkeleton = () => (
  <div className={styles.ecSearchGrid}>
    {Array.from(Array(PAGE_SIZE).keys()).map((index) => (
      <ListingCard key={index} loading />
    ))}
  </div>
)

const SearchGridList: FC<TProps> = ({
  listings,
  loading,
  showRecommendationsBanner,
  recommendationsLength,
}) => {
  const classesGrid = classNames(styles.ecSearchGrid, {
    [styles.ecSearchGridLoading]: loading,
    [styles.ecSearchGridNoResults]: !listings?.length,
  })

  if (loading) return <SearchGridListSkeleton />

  const visualizedIds: Array<string> =
    typeof window !== 'undefined' ? getEmCasaSessionListings() : []
  return (
    <div className={classesGrid}>
      {listings?.map((item, index) => {
        return (
          <Fragment key={`listing_${item?.id as string}`}>
            <SearchListingCard
              listing={item}
              cardProps={{
                visualized: !!item.id && visualizedIds.includes(item.id),
              }}
            />
            {(index === 1 || listings.length < 2) && showRecommendationsBanner && (
              <div className={styles.ecSearchGridBanner}>
                <RecommendationsBanner
                  recommendationsLength={recommendationsLength}
                />
              </div>
            )}
          </Fragment>
        )
      })}
    </div>
  )
}

export default memo(SearchGridList)
